/*
 * This is an event bus system so that publishers can publish events on the
 * event bus, and subscribers can then act on these events. Initially it was used
 * to ask for intercom user data update from within the store. But there could be
 * other suitable cases.
 * */
import Vue from 'vue'
export const EventBus = new Vue()
